import { render, staticRenderFns } from "./claimVouchers.vue?vue&type=template&id=898fd136&scoped=true"
import script from "./claimVouchers.vue?vue&type=script&lang=js"
export * from "./claimVouchers.vue?vue&type=script&lang=js"
import style0 from "./claimVouchers.vue?vue&type=style&index=0&id=898fd136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898fd136",
  null
  
)

export default component.exports